import type { OperationOverview } from "../api/types";
import { usePollingResource } from "./usePollingResource";

export function useOperationOverview(enabled = true) {
  const resource = usePollingResource<OperationOverview>(enabled ? "/operation/overview" : null);
  return { ...resource, overview: resource.data };
}
